import { configureStore } from '@reduxjs/toolkit'
import { setupListeners } from '@reduxjs/toolkit/query'
import { api } from './api.ts'
import clientReducer from './entities/client/slice.ts'
import projectReducer from './entities/project/slice.ts'

export const store = configureStore({
  reducer: {
    // RTK Query API slices
    [api.reducerPath]: api.reducer,
    // Custom entity slices
    client: clientReducer,
    project: projectReducer,
  },
  middleware: (getDefaultMiddleware) => getDefaultMiddleware().concat(api.middleware),
})

setupListeners(store.dispatch)

export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
